module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-4-zoom.753987d3.png";